import './BattleScreen.scss';
import './Game.scss';
import MonsterArea from './MonsterArea';
import PlayerArea from './PlayerArea';
import PlayerBlackjack from './PlayerBlackjack';
import StatusBar from './StatusBar';
import BackgroundImageAsset from "../Components/BackgroundImageAsset";
import PopUp from '../Components/Popup'
import { useAppSelector } from '../redux';
import { RootState } from '../store';
import { LOCATION_CLASSES } from '../Enums/Attributes'

function BattleScreen() {

  const gameState = useAppSelector((state: RootState) => state.game)
  const content = `A wild ${gameState.monster.name || ''} appears!`;
  const mapName = LOCATION_CLASSES.find(l => l.name === gameState.levelName).sprite
  return (
    <div className="battle-screen">

      <BackgroundImageAsset name={mapName} />
      <PlayerArea />

      <div className="game-area">
        <div className="game-area_row">
          <StatusBar />
        </div>
        <div className="game-area_row game-area_row-battle">
          <PlayerBlackjack />
          <MonsterArea />
          <PopUp />
        </div>


      </div>
    </div>
  );
}

export default BattleScreen;
